import { z } from "zod";

export const kitsWidgetStateSchema = z.json();

export const saveKitsWidgetStateInputSchema = z
    .object({
        conversationId: z.string().min(1),
        toolCallId: z.string().min(1),
        state: kitsWidgetStateSchema,
    })
    .strict();

export const getKitsWidgetStatesInputSchema = z.object({
    conversationId: z.string(),
});
export const quizStateSchema = z.object({
    index: z.number(),
    answers: z.record(z.string(), z.union([z.string(), z.array(z.string())])),
});
export const nullableQuizStateSchema = quizStateSchema.nullable();
export type QuizState = z.infer<typeof quizStateSchema>;
